import { type UseQueryResult, useQuery } from 'react-query';
import { GenderService } from '../../services/wealthlane-customer-services';

const useGetGender = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const GenderList = useQuery(
    ['getGenderList'],
    async () => {
      return await handleRequest(GenderService.getApiCustomerApiAppGenderGenderList());
    },
    {
      select: (data) => {
        return data
          ?.filter((item) => item.name !== 'I do not wish to provide')
          .map((item) => {
            return {
              label: item.name ?? '',
              value: item.id ?? '',
            };
          });
      },
    }
  );

  return GenderList;
};

export default useGetGender;
